import reducer from "./reducer";
export { default as ThirdParty } from "./components/index";
export { default as thirdPartyReducerName } from "./constants";
export default reducer;
